import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Input, Label, Row, Col, Table } from "reactstrap";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import Header from "../../../layout/Header/Header";
import Seccion from "../../Seccion";

const auth = () => ({ headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } });
const money = (v) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(v || 0);
const renglonVacio = () => ({ id: Math.random().toString(36).slice(2), articulos: "", vino: null, disponible: 0, cajas: 0, piezasPorCaja: 0, cantidad: 0, precio: 0 });

// Salida de vino a consignacion: baja de la cava, pero no genera saldo al cliente
function ConsignacionCreate() {
  const { user } = useContext(AuthContext);
  const URL_CONSIGNACIONES = process.env.REACT_APP_URL_CONSIGNACIONES;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;

  const [clientes, setClientes] = useState([]);
  const [areas, setAreas] = useState([]);
  const [vinos, setVinos] = useState([]);
  const [fecha, setFecha] = useState(moment().format("YYYY-MM-DD"));
  const [cliente, setCliente] = useState(null);
  const [area, setArea] = useState("");
  const [impuestos, setImpuestos] = useState(16);
  const [descuento, setDescuento] = useState(0);
  const [plazo, setPlazo] = useState(30);
  const [observaciones, setObservaciones] = useState("");
  const [renglones, setRenglones] = useState([renglonVacio()]);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    axios.get(process.env.REACT_APP_URL_CLIENTES, auth()).then((r) => setClientes(r.data.filter((c) => c.is_active === "Si"))).catch(console.log);
    axios
      .get(process.env.REACT_APP_URL_AREAS, auth())
      .then((r) => {
        const activas = r.data.filter((a) => a.is_active !== "No");
        setAreas(activas);
        const principal = activas.find((a) => a._id === process.env.REACT_APP_AREAS_CEDIS) || activas[0];
        if (principal) setArea(principal._id);
      })
      .catch(console.log);
  }, []);

  useEffect(() => {
    if (!area) return;
    axios.get(`${URL_INVENTARIOS}DisponibleAlmacen/${area}`, auth()).then((r) => setVinos(r.data)).catch(console.log);
    setRenglones([renglonVacio()]);
  }, [area, URL_INVENTARIOS]);

  const cambia = (id, cambios) => setRenglones((prev) => prev.map((r) => (r.id === id ? { ...r, ...cambios } : r)));

  function eligeVino(r, vino) {
    if (!vino) return cambia(r.id, { articulos: "", vino: null, disponible: 0, piezasPorCaja: 0, precio: 0, cajas: 0, cantidad: 0 });
    if (renglones.some((x) => x.id !== r.id && x.articulos === vino.idArticulo)) {
      Swal.fire({ icon: "warning", title: "Ese vino ya esta capturado" });
      return;
    }
    cambia(r.id, { articulos: vino.idArticulo, vino, disponible: vino.disponible, piezasPorCaja: vino.piezasPorCaja || 12, precio: vino.venta || 0 });
  }

  const totalBotellas = renglones.reduce((t, r) => t + (Number(r.cantidad) || 0), 0);
  const valor = renglones.reduce((t, r) => t + (Number(r.cantidad) || 0) * (Number(r.precio) || 0), 0);
  const excede = renglones.some((r) => Number(r.cantidad) > r.disponible);

  async function guardar(e) {
    e.preventDefault();
    if (!cliente) return Swal.fire({ icon: "warning", title: "Elige el cliente" });
    if (!totalBotellas) return Swal.fire({ icon: "warning", title: "Captura al menos un vino" });
    if (excede) return Swal.fire({ icon: "warning", title: "Hay mas botellas que disponible" });
    setGuardando(true);
    try {
      const { data } = await axios.post(
        URL_CONSIGNACIONES,
        {
          fecha,
          clientes: cliente._id,
          colaboradores: cliente.vendedor?.[0]?._id,
          areas: area,
          observaciones,
          impuestos,
          descuento,
          plazo,
          articulos: renglones.filter((r) => r.articulos).map((r) => ({ articulos: r.articulos, cantidad: r.cantidad, precio: r.precio })),
        },
        auth()
      );
      await Swal.fire("Listo", `Consignacion ${data.idConsignacion} creada`, "success");
      window.location.href = "/ListadoConsignaciones";
    } catch (error) {
      Swal.fire({ icon: "error", title: "No se guardo", text: error.response?.data?.message || "Intenta de nuevo" });
      setGuardando(false);
    }
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.consignaciones_create ? (
        <div className="card container">
          <h3 align="center">Nueva Consignación</h3>
          <form onSubmit={guardar}>
            <Seccion titulo="Datos de la consignación" icono="fas fa-handshake" ayuda="El vino sale de la cava y sigue siendo tuyo; el cliente solo debe lo que reporte vendido">
              <Row>
                <Col md={2}>
                  <Label>Fecha</Label>
                  <Input type="date" value={fecha} required onChange={(e) => setFecha(e.target.value)} />
                </Col>
                <Col md={4}>
                  <Label>Cliente</Label>
                  <Autocomplete
                    size="small"
                    value={cliente}
                    options={clientes}
                    getOptionLabel={(c) => c.nombre_comercial}
                    getOptionSelected={(a, b) => a._id === b._id}
                    onChange={(e, c) => {
                      setCliente(c);
                      if (c) setPlazo(c.plazo || 0);
                    }}
                    renderInput={(p) => <TextField {...p} variant="outlined" label="Selecciona" />}
                  />
                </Col>
                <Col md={2}>
                  <Label>Almacén</Label>
                  <Input type="select" value={area} required onChange={(e) => setArea(e.target.value)}>
                    {areas.map((a) => (
                      <option key={a._id} value={a._id}>{a.name}</option>
                    ))}
                  </Input>
                </Col>
                <Col md={2}>
                  <Label>IVA</Label>
                  <Input type="select" value={impuestos} onChange={(e) => setImpuestos(Number(e.target.value))}>
                    <option value={16}>16%</option>
                    <option value={0}>Sin IVA</option>
                  </Input>
                </Col>
                <Col md={1}>
                  <Label>Desc. %</Label>
                  <Input type="number" min="0" max="100" value={descuento} onChange={(e) => setDescuento(Number(e.target.value))} />
                </Col>
                <Col md={1}>
                  <Label>Plazo</Label>
                  <Input type="number" min="0" value={plazo} onChange={(e) => setPlazo(Number(e.target.value))} />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Label>Observaciones</Label>
                  <Input type="text" value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />
                </Col>
              </Row>
            </Seccion>
            <Seccion titulo="Vinos" icono="fas fa-wine-bottle">
              <Table size="sm" borderless>
                <thead>
                  <tr>
                    <th style={{ width: "36%" }}>Vino</th>
                    <th>Disponible</th>
                    <th>Cajas</th>
                    <th>Botellas</th>
                    <th>Precio</th>
                    <th>Importe</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {renglones.map((r) => (
                    <tr key={r.id}>
                      <td>
                        <Autocomplete
                          size="small"
                          value={r.vino}
                          options={vinos}
                          getOptionLabel={(v) => `${v.codigo} ${v.nombre}`}
                          getOptionSelected={(a, b) => a.idArticulo === b.idArticulo}
                          onChange={(e, v) => eligeVino(r, v)}
                          renderInput={(p) => <TextField {...p} variant="outlined" label="Selecciona" />}
                        />
                      </td>
                      <td>{new Intl.NumberFormat("en-US").format(r.disponible)}</td>
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          min="0"
                          step="any"
                          value={r.cajas}
                          disabled={!r.articulos}
                          onChange={(e) => cambia(r.id, { cajas: e.target.value, cantidad: (Number(e.target.value) || 0) * r.piezasPorCaja })}
                        />
                      </td>
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          min="0"
                          name="cantidad"
                          invalid={Number(r.cantidad) > r.disponible}
                          value={r.cantidad}
                          disabled={!r.articulos}
                          onChange={(e) => cambia(r.id, { cantidad: e.target.value, cajas: r.piezasPorCaja ? (Number(e.target.value) || 0) / r.piezasPorCaja : 0 })}
                        />
                      </td>
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          min="0"
                          step="any"
                          name="precio"
                          value={r.precio}
                          disabled={!r.articulos || !user.cambiaPrecios}
                          onChange={(e) => cambia(r.id, { precio: e.target.value })}
                        />
                      </td>
                      <td>{money((Number(r.cantidad) || 0) * (Number(r.precio) || 0))}</td>
                      <td>
                        <Button size="sm" color="danger" title="Quitar" disabled={renglones.length === 1}
                          onClick={() => setRenglones((prev) => prev.filter((x) => x.id !== r.id))}>
                          <i className="fas fa-minus" />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <Button size="sm" color="info" onClick={() => setRenglones((prev) => [...prev, renglonVacio()])}>
                <i className="fas fa-plus" /> Agregar vino
              </Button>
              <p className="mt-3 mb-0">
                <strong>{new Intl.NumberFormat("en-US").format(totalBotellas)}</strong> botellas por{" "}
                <strong>{money(valor)}</strong> antes de impuestos
              </p>
            </Seccion>
            <Button href="/ListadoConsignaciones" color="danger">Regresar</Button>{" "}
            <Button type="submit" color="success" disabled={guardando}>Guardar</Button>
          </form>
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default ConsignacionCreate;
